import {Link} from '@github-ui/react-core/link'
import {useLocation} from '@github-ui/react-router'
import {NavList} from '@primer/react'
import {Tooltip} from '@primer/react/deprecated'
import type React from 'react'

type SidebarRowProps = {
  icon: React.ElementType
  title: string
  id: string
  path: string
  tooltip: string
  onClick?: () => void
}

export function SidebarRow({icon: Icon, title, id, path, tooltip, onClick}: SidebarRowProps) {
  // Read pathname via useLocation so the active-page indicator reacts to SPA
  // navigation. Reading ssrSafeLocation at render scope is frozen by the
  // React Compiler and leaves aria-current="page" stuck on the first route.
  const {pathname} = useLocation()
  const components = pathname.split('/')
  const suffix = components.length === 0 ? '' : components[components.length - 1]

  return (
    <NavList.Item as={Link} aria-current={suffix === id ? 'page' : undefined} to={path} onClick={onClick}>
      <NavList.LeadingVisual>
        <Icon />
      </NavList.LeadingVisual>
      <Tooltip aria-label={tooltip}>{title}</Tooltip>
    </NavList.Item>
  )
}
